import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

export const cancelStopLoss = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<void, string>({
    query: (request) => ({
      url: '/oms/cancel/StopLoss',
      method: 'POST',
      body: { orderRef: request },
      headers: {
        // without this header, the response is a string
        // instead of JSON, even if the value is "application/json"
        //accept: '*/*',
      },
    }),
  });
};
